import { useEffect, useRef } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useSessionUserId, useVisitorId } from "@/hooks/use-portal-identity";

/**
 * Registra una visita al detalle de un anuncio (fire-and-forget).
 * - Reutiliza el mismo visitor id persistente que el tracking de impresiones.
 * - Si el usuario está logueado se omite p_visitor_id (el RPC usa auth.uid()).
 * - Se dispara una sola vez por anuncio y visita.
 */
export function useTrackAnuncioView(anuncioId: string | null | undefined) {
  const userId = useSessionUserId();
  const visitorId = useVisitorId();
  const sentRef = useRef<string | null>(null);

  useEffect(() => {
    if (!anuncioId) return;
    // Esperamos a resolver identidad (usuario o visitante) antes de enviar.
    if (!userId && !visitorId) return;
    if (sentRef.current === anuncioId) return;
    sentRef.current = anuncioId;

    const vid = (visitorId ?? "").trim();
    const payload: { p_anuncio_id: string; p_visitor_id?: string } = { p_anuncio_id: anuncioId };
    if (!userId && vid.length >= 8 && vid.length <= 128) payload.p_visitor_id = vid;

    void (supabase.rpc as any)("track_anuncio_view", payload).then(
      () => {},
      () => {},
    );
  }, [anuncioId, userId, visitorId]);
}
